import React from "react";
import "./index.css";
import logo from "../../assets/images/schmodelplain-withR-white.png";

const IOS_APP_URL = "https://apps.apple.com/app/id6744175519";
const ANDROID_APP_URL = "https://play.google.com/store/apps/details?id=com.schmodel.app";

// Where Stripe sends the member after a successful Checkout.
function PaymentSuccess() {
    return (
        <div className="payment-container">
            <div className="payment-main">
                <svg className="payment-icon" viewBox="0 0 48 48" aria-hidden="true">
                    <circle cx="24" cy="24" r="22" fill="none" stroke="#B08D57" strokeWidth="1.5" />
                    <path d="M15 24.5l6.5 6.5L33 18" fill="none" stroke="#B08D57" strokeWidth="1.5"
                          strokeLinecap="round" strokeLinejoin="round" />
                </svg>

                Thank you for your payment.<br />
                Your membership is now active.

                <a className="payment-cta" href={IOS_APP_URL}>Download for iPhone</a>
                <a className="payment-cta" href={ANDROID_APP_URL}>Download for Android</a>

                <p className="payment-note">A receipt is on its way to your email.</p>
            </div>
            <div className="payment-footer">
                <img src={logo} className="payment-logo" alt="Schmodel" />
            </div>
        </div>
    );
}

export default PaymentSuccess;
